import React, { useEffect, useState, useRef, useContext } from 'react';
import styles from './ApplicationsPage.module.scss';
import QuizDetails from '../../Molecules/detailsBox/quizDetailsBox';
import TableTopHeader from '../../Molecules/TableTopHeader/ApplicationsTableTopHeader';
import ApplicantsTable from '../../Molecules/Applications/ApplicantsTable';
import {
  DetailsContext,
  PageTitleContext,
} from '../../HOC/GeneralBody/GeneralBody';
import {
  useFetchQuizzes,
  useExportTableQuizzes,
  useFetchSingleQuiz,
} from '../../../Hooks/Applications';

const ApplicationsPage = () => {
  const [Page, setPage] = useState(1);
  const [PageSize, setPageSize] = useState(10);
  const HeaderAttr = useContext(PageTitleContext);
  const Details = useContext(DetailsContext);
  const [selected, setSelected] = useState('quizzes');
  const [quizNumber, setQuizNumber] = useState(0);
  const [applicationId, setApplicationId] = useState('');

  const quizzesTableHeader = [
    {
      name: 'Name',
      originalName: 'userName',
    },
    {
      name: 'Email',
      originalName: 'userEmail',
    },
    {
      name: 'Degree',
      originalName: 'degreeNameEn',
    },
    {
      name: 'Suggested Program',
      originalName: 'entryLevelEn',
    },
    {
      name: 'Date',
      originalName: 'date',
    },
  ];
  const [search, setSearch] = useState();
  const [order, setOrder] = useState(['', 'asc']);
  const [mode, setMode] = useState('quizzes');

  const {
    data: quizzes,
    refetch: refetchQuizzes,
    isLoading: isLoading,
  } = useFetchQuizzes({
    pageSize: PageSize,
    pageNumber: Page,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const {
    data: quizzesPrint,
    refetch: refetchQuizzesPrint,
    isLoading: isLoading0013,
  } = useFetchQuizzes({
    pageSize: 10000,
    pageNumber: 1,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const { data: QuizbyId, refetch: refetchSingleQuiz } = useFetchSingleQuiz(
    Details.details
  );

  const exportQuizzesTable = useExportTableQuizzes();
  const handleExportTable = async () => {
    try {
      var data = await exportQuizzesTable.mutateAsync();

      if (data.data instanceof Blob) {
        const blob = new Blob([data.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'QuizesTable';
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        console.error('Unexpected data type. Expected string.');
      }
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };
  useEffect(() => {
    if (Details.details) {
      HeaderAttr.setMoveRight('40px');
      refetchSingleQuiz();
      HeaderAttr.setPathName('Quiz Details');
    } else {
      HeaderAttr.setMoveRight('2px');
      HeaderAttr.setPathName('Quizzes');
      Details.setDetails(null);
    }
  }, [Details.details]);

  useEffect(() => {
    refetchQuizzes();
  }, [Page, PageSize, search, order]);

  useEffect(() => {
    if (quizzes && !quizNumber) {
      setQuizNumber(quizzes && quizzes.data.length);
    }
  }, [quizzes]);

  const [moveRight, setMoveRight] = useState(false);

  useEffect(() => {
    setSearch('');
    setPage(1);
    setPageSize(10);
    setOrder(['', 'asc']);
  }, [selected]);

  useEffect(() => {}, []);

  return (
    <>
      {!Details.details ? (
        <div className={styles['container']}>
          <div className={styles['search-container']}>
            <div className={styles['table-container']}>
              <TableTopHeader
                mode={mode}
                handleExport={handleExportTable}
                search={search}
                setSearch={setSearch}
                title="Quizes Table"
                data={quizzesPrint?.data}
                refetch={refetchQuizzesPrint}
                tableHeader={quizzesTableHeader}
              />
              <ApplicantsTable
                data={quizzes?.data}
                tableHeader={quizzesTableHeader}
                mode={mode}
                page={Page}
                setPage={setPage}
                pageSize={PageSize}
                setPageSize={setPageSize}
                isApplicantsLoading={isLoading}
                setDetails={Details.setDetails}
                details={Details.details}
                setApplicationId={setApplicationId}
                order={order}
                setOrder={setOrder}
                refetch={refetchQuizzes}
                setMoveRight={setMoveRight}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <QuizDetails
            data={QuizbyId?.data}
            setDetails={Details.setDetails}
            details={Details.details}
            refetchSingleQuiz={refetchSingleQuiz}
            setMoveRight={setMoveRight}
            moveRight={moveRight}
          />
        </>
      )}
    </>
  );
};

export default ApplicationsPage;
